/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.PortalDataRpc
 */
import * as References from './PortalDataRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.PortalDataRpc#getPortalData
 */
export const GET_PORTAL_DATA_QUERY_FIELD_NAME = 'com_hubspot_support_portal_rpc_PortalDataRpc_getPortalData';
export const GET_PORTAL_DATA_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_DATA_QUERY_FIELD_NAME,
  args: ['accountId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPortalDataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});